var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedeemReward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 26,
    r: 9,
    style: {},
    fill: "#fed856",
    "data-original": "#fed856"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 26,
    r: 9,
    style: {},
    fill: "#fed856",
    "data-original": "#fed856"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 13,
    r: 9,
    style: {},
    fill: "#fed856",
    "data-original": "#fed856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 40h34v21H21z",
    style: {},
    fill: "#c69c6d",
    "data-original": "#c69c6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 40h5v21h-5z",
    style: {},
    fill: "#fbb03b",
    "data-original": "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 61H8V46l1-6h12v21z",
    style: {},
    fill: "#a67c52",
    "data-original": "#a67c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 40 6 6H27l-6-6h34z",
    style: {},
    fill: "#8c6239",
    "data-original": "#8c6239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 40h5v21h-5z",
    style: {},
    fill: "#fbb03b",
    "data-original": "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 40-6 6h12l6-6H9z",
    style: {},
    fill: "#8c6239",
    "data-original": "#8c6239"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 60h-2v-9h3v-2h-3v-2h5a1 1 0 0 0 .707-1.707l-6-6A1 1 0 0 0 55 39H9a1 1 0 0 0-.707.293l-6 6A1 1 0 0 0 3 47h4v13H2v2h56Zm-4 0H42v-9h12ZM20 44v16h-2V44.414l3-3 5.293 5.293A1 1 0 0 0 27 47h8v2h-4v2h4v9H22V44Zm-5 3a1 1 0 0 0 .707-.293l.293-.293V60h-3V47Zm25 0v2h-3v-2Zm-3 4h3v9h-3Zm17-2H42v-2h12Zm.586-8 4 4H27.414l-4-4ZM9.414 41h9.172l-4 4H5.414ZM9 47h2v13H9Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h2v2h-2zM60 60h2v2h-2zM9.361 26.6a2.839 2.839 0 0 0 2.921.689l2.069-.689a.854.854 0 0 1 .874 1.414l-.207.207a.855.855 0 0 1-1.208 0l-.1-.1-1.414 1.414.1.1a2.818 2.818 0 0 0 3.33.5l.81.81 1.414-1.414-.81-.81a2.843 2.843 0 0 0-3.422-4.019l-2.069.689a.854.854 0 0 1-.874-1.414l.207-.207a.855.855 0 0 1 1.208 0l.1.1 1.414-1.414-.1-.1a2.847 2.847 0 0 0-3.33-.5l-.81-.81-1.414 1.418.81.81a2.849 2.849 0 0 0 .501 3.326Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 26a10 10 0 0 0 17.071 7.071A10 10 0 1 0 5.929 18.929 9.934 9.934 0 0 0 3 26Zm10-8a8 8 0 1 1-5.657 2.343A7.948 7.948 0 0 1 13 18ZM55.536 21.05l-.81.81a2.843 2.843 0 0 0-4.019 3.422l.689 2.069a.854.854 0 0 1-1.414.874l-.207-.207a.855.855 0 0 1 0-1.208l.1-.1-1.414-1.414-.1.1a2.849 2.849 0 0 0-.5 3.33l-.81.81 1.414 1.414.81-.81a2.843 2.843 0 0 0 4.019-3.422l-.694-2.069a.854.854 0 0 1 1.414-.874l.207.207a.855.855 0 0 1 0 1.208l-.1.1 1.414 1.414.1-.1a2.849 2.849 0 0 0 .5-3.33l.81-.81Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 16a10 10 0 1 0 7.071 2.929A9.934 9.934 0 0 0 52 16Zm5.657 15.657A8 8 0 1 1 60 26a7.948 7.948 0 0 1-2.343 5.657ZM34 8.145V7h-2v1.145a2.844 2.844 0 0 0-.422 5.262l1.949.974A.854.854 0 0 1 33.146 16h-.292a.855.855 0 0 1-.854-.854V15h-2v.146a2.849 2.849 0 0 0 2 2.709V19h2v-1.145a2.844 2.844 0 0 0 .422-5.262l-1.949-.974A.854.854 0 0 1 32.854 10h.292a.855.855 0 0 1 .854.854V11h2v-.146a2.849 2.849 0 0 0-2-2.709Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 13a10 10 0 1 0-10 10 10.011 10.011 0 0 0 10-10Zm-10 8a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8ZM31 25h2v12h-2zM35 37h2v-4a2 2 0 0 1 2-2v-2a4 4 0 0 0-4 4ZM29 37v-6a4 4 0 0 0-4-4v2a2 2 0 0 1 2 2v6Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.308 2.9A13.885 13.885 0 0 0 19 13q0 .543.041 1.077l1.994-.154Q21 13.467 21 13a11.9 11.9 0 0 1 3.692-8.659ZM4 5h2v2H4zM11 10h2v2h-2zM3 37h2v2H3zM60 37h2v2h-2zM46 4h2v2h-2zM56 11h2v2h-2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemReward);
export default __webpack_public_path__ + "static/media/redeem_reward.ad61578535afc8983242998ec9d9bd4a.svg";
export { ForwardRef as ReactComponent };